import { render, staticRenderFns } from "./TemplateDetailsPageSettings.vue?vue&type=template&id=65db9d88&scoped=true"
import script from "./TemplateDetailsPageSettings.vue?vue&type=script&lang=js"
export * from "./TemplateDetailsPageSettings.vue?vue&type=script&lang=js"
import style0 from "./TemplateDetailsPageSettings.vue?vue&type=style&index=0&id=65db9d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65db9d88",
  null
  
)

export default component.exports